import { z } from 'zod';

import { ErrorResponse } from './common.js';

export const OmniAuthAccountSchema = z.object({
  id: z.string(),
  name: z.string(),
  isConnected: z.boolean().optional(),
});

export const OmniAuthAccountsSchema = z.array(OmniAuthAccountSchema);

export const OmniAuthAccountResponseSchema = z.object({
  data: z.object({
    items: OmniAuthAccountsSchema,
  }),
  error: ErrorResponse.optional(),
});

export const OmniAuthQuerySchema = z.object({
  connectionId: z.string().optional(),
});
